<template>
  <div class="add-shipment-page">

    <!-- Header -->
    <div class="page-header gradient-header animated fadeInDown">
      <h1><i class="fas fa-truck-loading"></i> Add Shipment</h1>
      <p>Fill in the shipment details below</p>
    </div>

    <!-- Shipment Form -->
    <div class="shipment-form animated fadeInUp">
      <form @submit.prevent="submitForm">
        <!-- Row 1: Factory & Supplier | Destination & Cubes -->
        <div class="form-row">
          <!-- Factory & Supplier -->
          <div class="form-section gradient-section">
            <h3>Factory & Supplier</h3>
            <div class="form-group">
              <label>Factory</label>
              <select v-model="shipment.factory_id" required>
                <option value="" disabled>Select Factory</option>
                <option v-for="factory in factories" :key="factory.id" :value="factory.id">
                  {{ factory.name }}
                </option>
              </select>
              <small v-if="errors.factory_id" class="error-msg">{{ errors.factory_id[0] }}</small>
            </div>
           <div class="form-group">

  <label>Select Supplier</label>
  <select v-model="shipment.supplier_id" @change="setSupplierName" required>
    <option
      v-for="s in allSuppliers"
      :key="s.id"
      :value="s.id"
    >
      {{ s.name }}
    </option>
  </select>

  <!-- Hidden supplier name -->
  <input type="hidden" v-model="shipment.supplier" />

  <small v-if="errors.supplier_id" class="error-msg">
    {{ errors.supplier_id[0] }}
  </small>

</div>
</div>

          <!-- Destination & Cubes -->
          <div class="form-section gradient-section-alt">
            <h3>Destination & Quantity</h3>
            <div class="form-group">
              <label>Destination</label>
              <select v-model="shipment.destination" required>
                <option value="" disabled>Select Factory</option>
                <option v-for="factory in factories" :key="factory.id" :value="factory.id">
                  {{ factory.name }}
                </option>
              </select>

              <small v-if="errors.destination" class="error-msg">{{ errors.destination[0] }}</small>
            </div>
            <div class="form-group">
              <label>Approx Cubes</label>
              <input v-model="shipment.approxCubes" type="number" min="1" required />
              <small v-if="errors.approxCubes" class="error-msg">{{ errors.approxCubes[0] }}</small>
            </div>
            <div class="form-group">
              <label>Actual Cubes</label>
              <input v-model="shipment.actualCubes" type="number" min="0" />
              <small v-if="errors.actualCubes" class="error-msg">{{ errors.actualCubes[0] }}</small>
            </div>
          </div>
        </div>

        <!-- Row 2: Status | Dates -->
        <div class="form-row">
          <!-- Status -->
          <div class="form-section gradient-section">
            <h3>Status</h3>
            <div class="form-group">
              <label>Delivery Status</label>
              <select v-model="shipment.deliveryStatus" required>
                <option>active</option>
                <option>completed</option>
                <option>pending</option>
              </select>
              <small v-if="errors.deliveryStatus" class="error-msg">{{ errors.deliveryStatus[0] }}</small>
            </div>
            <div class="form-group">
              <label>Payment Status</label>
              <select v-model="shipment.paymentStatus" required>
                <option>unpaid</option>
                <option>partial</option>
                <option>paid</option>
              </select>
              <small v-if="errors.paymentStatus" class="error-msg">{{ errors.paymentStatus[0] }}</small>
            </div>
            <div class="form-group">
              <label>Advance Payment</label>
              <input v-model="shipment.advancePayment" type="number" min="0" />
              <small v-if="errors.advancePayment" class="error-msg">{{ errors.advancePayment[0] }}</small>
            </div>
          </div>

          <!-- Dates -->
          <div class="form-section gradient-section-alt">
            <h3>Dates</h3>
            <div class="form-group">
              <label>Created Date</label>
              <input v-model="shipment.createdDate" type="date" />
              <small v-if="errors.createdDate" class="error-msg">{{ errors.createdDate[0] }}</small>
            </div>
            <div class="form-group">
              <label>Dispatch Date</label>
              <input v-model="shipment.dispatchDate" type="date" />
              <small v-if="errors.dispatchDate" class="error-msg">{{ errors.dispatchDate[0] }}</small>
            </div>
            <div class="form-group">
              <label>Delivered Date</label>
              <input v-model="shipment.deliveredDate" type="date" />
              <small v-if="errors.deliveredDate" class="error-msg">{{ errors.deliveredDate[0] }}</small>
            </div>
            <div class="form-group">
              <label>Payment Date</label>
              <input v-model="shipment.paymentDate" type="date" />
              <small v-if="errors.paymentDate" class="error-msg">{{ errors.paymentDate[0] }}</small>
            </div>
          </div>
        </div>

        <!-- Row 3: Truck & Driver | Location -->
        <div class="form-row">
          <!-- Truck & Driver -->
          <div class="form-section gradient-section">
            <h3>Truck & Driver</h3>
            <div class="form-group">
              <label>Truck Number</label>
              <input v-model="shipment.truckNo" type="text" placeholder="Truck Number" />
              <small v-if="errors.truckNo" class="error-msg">{{ errors.truckNo[0] }}</small>
            </div>
            <div class="form-group">
              <label>Driver Name</label>
              <input v-model="shipment.driverName" type="text" placeholder="Driver Name" />
              <small v-if="errors.driverName" class="error-msg">{{ errors.driverName[0] }}</small>
            </div>
            <div class="form-group">
              <label>Driver Phone</label>
              <input v-model="shipment.driverPhone" type="text" placeholder="Driver Phone" />
              <small v-if="errors.driverPhone" class="error-msg">{{ errors.driverPhone[0] }}</small>
            </div>
             <div class="form-group">
              <label>Total Delivery charges</label>
              <input v-model="shipment.deliveryCharges" type="text" placeholder="Truck Number" />
              <small v-if="errors.truckNo" class="error-msg">{{ errors.truckNo[0] }}</small>
            </div>
            <div class="form-group">
              <label>delivery installement</label>
              <input v-model="shipment.deliveryInstallement" type="text" placeholder="Driver Name" />
              <small v-if="errors.driverName" class="error-msg">{{ errors.driverName[0] }}</small>
            </div>
            <div class="form-group">
              <label>Delivery balance</label>
              <input v-model="shipment.deliveryBalance" type="text" placeholder="Driver Phone" />
              <small v-if="errors.driverPhone" class="error-msg">{{ errors.driverPhone[0] }}</small>
            </div>
          </div>

          <!-- Location -->
          <div class="form-section gradient-section-alt">
            <h3>Good source Location</h3>
            <div class="form-group">
              <label>Name(Town/City)</label>
              <input v-model="shipment.source" type="text" step="any" placeholder="Town/City/Location" />
              <small v-if="errors.latitude" class="error-msg">{{ errors.latitude[0] }}</small>
            </div>
            <div class="form-group">
              <label>Latitude</label>
              <input v-model="shipment.latitude" type="number" step="any" placeholder="Latitude" />
              <small v-if="errors.latitude" class="error-msg">{{ errors.latitude[0] }}</small>
            </div>
            <div class="form-group">
              <label>Longitude</label>
              <input v-model="shipment.longitude" type="number" step="any" placeholder="Longitude" />
              <small v-if="errors.longitude" class="error-msg">{{ errors.longitude[0] }}</small>
            </div>
          </div>
        </div>

        <!-- Image Upload Section -->
        <div class="form-section gradient-section">
          <h3>Shipment Images</h3>
          <div class="form-group">
            <input type="file" multiple @change="handleImagesUpload" />
          </div>
          <div class="image-gallery">
            <div v-for="(img, i) in images" :key="i" class="image-item">
              <img :src="img" alt="Shipment Image" />
            </div>
          </div>
        </div>

        <!-- Buttons -->
        <div class="form-actions">
          <button class="btn btn-gradient" type="submit" :disabled="loading">
            <span v-if="loading"><i class="fas fa-spinner fa-spin"></i> Saving...</span>
            <span v-else>Save Shipment</span>
          </button>
          <button type="button" class="btn btn-secondary" @click="$router.back()">Cancel</button>
        </div>
      </form>
    </div>

    <!-- Notifications -->
    <Notifications ref="notify" />
  </div>
</template>

<script>
import Notifications from "../Notifications.vue";

export default {
  name: "AddShipmentComponent",
  components: { Notifications },
  data() {
    return {
      shipment: {
        factory_id: '',
        supplier_id: "",
        supplier: "",
        destination: '',
        approxCubes: 0,
        actualCubes: 0,
        deliveryStatus: 'active',
        paymentStatus: 'unpaid',
        advancePayment: 0,
        createdDate: null,
        dispatchDate: null,
        deliveredDate: null,
        deliveredCharges: null,
        deliveredInstallement: null,
        deliveredBalance: null,
        paymentDate: null,
        source: null,
        truckNo: '',
        driverName: '',
        driverPhone: '',
        latitude: null,
        longitude: null,
        images: [],
      },
      images: [],
      factories: [],
      loading: false,
      errors: {},
    };
  },
  computed:{
    allSuppliers() {
    return this.$store.getters["suppliers/allSuppliers"];
  },
  },
  methods: {
    async fetchFactories() {
      await this.$store.dispatch('factories/fetchFactories');
      this.factories = this.$store.state.factories.factories || [];
    },
    handleImagesUpload(event) {
      const files = Array.from(event.target.files);
      files.forEach(file => {
        const reader = new FileReader();
        reader.onload = e => this.images.push(e.target.result);
        reader.readAsDataURL(file);
      });
      this.shipment.images = this.images;
    },
    setSupplierName() {
    const selected = this.allSuppliers.find(s => s.id === this.shipment.supplier_id);
    this.shipment.supplier = selected ? selected.name : "";
  },
    async submitForm() {
      this.loading = true;
      this.errors = {};
      try {
        await this.$store.dispatch('shipments/addShipment', this.shipment);
        this.$refs.notify.success('Shipment added successfully!');
        this.$router.push({ name: 'Shipments' });
      } catch (err) {
        if (err.response?.status === 422) {
          this.errors = err.response.data.error || err.response.data.errors || {};
          this.$refs.notify.error('Please correct the highlighted errors.');
        } else {
          this.$refs.notify.error('Failed to add shipment: ' + (err.message || 'Unknown error'));
        }
        console.error('Add Shipment Error:', err);
      } finally {
        this.loading = false;
      }
    }
  },
  mounted() {
    this.fetchFactories();
  }
};
</script>

<style scoped>
.add-shipment-page { width: 100%; padding: 20px; background: #f0f2f5; }

/* Header */
.page-header {
  text-align: center;
  color: #fff;
  padding: 30px 15px;
  border-radius: 12px;
  margin-bottom: 20px;
}
.gradient-header { background: linear-gradient(135deg, #6a82fb, #fc5c7d); }

/* Form wrapper */
.shipment-form { max-width: 1200px; margin: auto; padding: 20px; }

/* Form Row for 2 sections per row */
.form-row { display: flex; flex-wrap: wrap; gap: 20px; margin-bottom: 20px; }
.form-row > .form-section { flex: 1 1 100%; }
@media (min-width: 768px) { .form-row > .form-section { flex: 1 1 calc(50% - 10px); } }

/* Form sections */
.form-section { padding: 20px; border-radius: 12px; box-shadow: 0 5px 15px rgba(0,0,0,0.05); }
.gradient-section { background: linear-gradient(135deg, #6a11cb, #2575fc); color: #fff; }
.gradient-section-alt { background: linear-gradient(135deg, #11998e, #38ef7d); color: #fff; }

h3 { margin-bottom: 15px; }

/* Inputs */
.form-group { margin-bottom: 15px; }
label { font-weight: 600; display: block; margin-bottom: 5px; }
input, select { width: 100%; padding: 10px; border-radius: 6px; border: none; }

.error-msg { color: #ffcccc; font-size: 0.85em; margin-top: 3px; display: block; }

/* Buttons */
.form-actions { display: flex; gap: 15px; justify-content: flex-end; margin-top: 25px; }
.btn { padding: 10px 25px; border-radius: 8px; border: none; cursor: pointer; transition: all 0.3s; }
.btn-gradient { background: linear-gradient(135deg, #6a82fb, #fc5c7d); color: #fff; }
.btn-gradient:hover { transform: scale(1.05); }
.btn-secondary { background: #6c757d; color: #fff; }
.btn-secondary:hover { background: #5a6268; }

/* Image gallery */
.image-gallery { display: flex; flex-wrap: wrap; gap: 10px; margin-top: 10px; }
.image-item img { width: 120px; height: 90px; object-fit: cover; border-radius: 8px; }
</style>
